const transactionCategoryConstants = {
  Free: 'Free',
  Social: 'Social',
  INR: 'INR',
};

export default transactionCategoryConstants;



// WEBPACK FOOTER //
// ./src/common/analytics/transactionCategoryConstants.js